import { useContext } from "react";
import {
  AuthCheckpointContext,
  type IAuthCheckpointContext,
} from "../context/AuthCheckpointContext";

export const useAuthCheckpoint = (): IAuthCheckpointContext | null =>
  useContext(AuthCheckpointContext);
